
<div class="audit-index" v-if="data">
    <div
        :id    = "'scroll-category'"
        :class = "horizontal ? 'scroll-area-horizontal' : 'scroll-area-vertical'"
        :style = "'max-height: ' + (height) + 'px'"
    >
        <v-card
            v-for      = "(entry, index) in entries"
            :id        = "entry.id"
            :key       = "'cat_' + index"
            :elevation = "0"
            :outlined  = "false"
            :rounded   = "false"
            class      = "index-item"
            :class     = "border(index) + ' ' + selectedFrame(entry, selected) + ' ' + constraintBackground(entry)"
            @click     = "onClick (entry.id)"
        >
            <div class="marker-dot" :class="dotBackground(entry, data)">
            </div>

            <div class="pa-1 pl-3 pr-4" style="height: 35px">
                {{ code(entry) }}
            </div>
        </v-card>
    </div>
</div>
